import { useContext } from "react";
import { ContextState } from "..";
import UserMenu from "./UserMenu";
import Cookies from 'js-cookie';

const Header = ({ isAuthenticated, history, setMenuOpen, menuOpen, handleLogout }) => {
    const { contextReducer, setContextReducer } = useContext(ContextState);
    const role = Cookies.get('cms_role');

    const setTypeCMS = (type) => {
        setContextReducer({ cms_type: type });
        localStorage.setItem('cms_type', type);
    }

    return (
        <>
            <div className="header">
                <div className="header_logo">
                    <img src={require('../../assets/images/skill_up_logo.svg').default} alt="Skill Up With USC Online" className="cursor_pointer" />
                </div>
                {history.location.pathname !== '/sso-log' &&
                    <div className="header_heading d_flex">
                        {!isAuthenticated
                            ? <h1>User &amp; content management system</h1>
                            : <ul className='list_unstyled d_flex submission_tabs pre_college'>
                                <li onClick={() => setTypeCMS('skill-up')} className={`text_uppercase cursor_pointer ${contextReducer.cms_type === 'skill-up' ? 'active' : ''}`}>Skill up</li>
                                {/* {role === "Admin" && <li onClick={() => setTypeCMS('skill-up')} className={`text_uppercase cursor_pointer ${contextReducer.cms_type === 'skill-up' ? 'active' : ''}`}>Skill up CMS</li>} */}
                                <li onClick={() => setTypeCMS('pre-college')} className={`text_uppercase cursor_pointer ${contextReducer.cms_type === 'pre-college' ? 'active' : ''}`}>Pre-College</li>
                                {(role === "Admin" || role === "Main Admin") && <li onClick={() => setTypeCMS('career-launch')} className={`text_uppercase cursor_pointer ${contextReducer.cms_type === 'career-launch' ? 'active' : ''}`}>Career-Launchpad</li>}
                                <li onClick={() => setTypeCMS('certificates')} className={`text_uppercase cursor_pointer ${contextReducer.cms_type === 'certificates' ? 'active' : ''}`}>Certificates</li>
                                <li onClick={() => setTypeCMS('dl-program')} className={`text_uppercase cursor_pointer ${contextReducer.cms_type === 'dl-program' ? 'active' : ''}`}>DL Program</li>
                            </ul>
                        }
                    </div>
                }

                <UserMenu
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                    handleLogout={handleLogout}
                    isAuthenticated={isAuthenticated}
                />
            </div>
        </>
    )
};

export default Header